var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Stack } from 'syf-component-library/ui/spacing';
import Grid from 'syf-component-library/ui/patterns/Grid';
import Title from './subcomponents';
var ContentHeader = function (_a) {
    var content = _a.content, size = _a.size;
    var questionRef = useRef(null);
    useEffect(function () {
        questionRef.current.focus();
    }, [content]);
    return (_jsxs(Grid, __assign({ container: true, direction: "column" }, { children: [_jsx(Grid, __assign({ item: true }, { children: _jsx(Stack, { size: "large" }) })), _jsx(Title, __assign({ weight: "bold", as: "h2", id: "disputes-label", tabIndex: -1, ref: questionRef }, { children: content })), _jsx(Grid, __assign({ item: true }, { children: _jsx(Stack, { size: size || 'large' }) }))] })));
};
export default ContentHeader;
//# sourceMappingURL=index.js.map